"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreMerchantRequirementScopeEnum = void 0;
/**
 * Наименования форм
 */
var BillingCoreMerchantRequirementScopeEnum;
(function (BillingCoreMerchantRequirementScopeEnum) {
  /** Профиль поставщика */
  BillingCoreMerchantRequirementScopeEnum["SUPPLIER"] = "SUPPLIER";
  /** Форма банковских реквизитов */
  BillingCoreMerchantRequirementScopeEnum["ACCOUNT"] = "ACCOUNT";
})(BillingCoreMerchantRequirementScopeEnum = exports.BillingCoreMerchantRequirementScopeEnum || (exports.BillingCoreMerchantRequirementScopeEnum = {}));
